$(document).ready(function () {
    let export_date = {
        start: null,
        end: null
    };
    //Range Picker for step two
    if (document.getElementById('export-date-start')) {
        new Lightpick({
            field: document.getElementById('export-date-start'),
            secondField: document.getElementById('export-date-end'),
            singleDate: false,
            format: 'MM/DD/YYYY',
            onSelect: function (start, end) {
                export_date.start = start ? start.format('DD-MM-YYYY') : null;
                export_date.end = end ? end.format('DD-MM-YYYY') : null;
            }
        });
    }

    //Select market and client
    $(document).on('change', '#export-market-client', function () {
        let option = $('#export-market-client option:selected');
        $('#export-market-id').val(option.data('market_id'));
        $('#export-client-id').val(option.data('client_id'));
    });

    //Get converted data then save
    $(document).on('click', '#export-process', function (e) {
        e.preventDefault();

        let button = $(this);
        button.attr('disabled', true);
        button.find('.fa').hide();
        button.find('.fa-spinner').show();

        let form = $('#export-process-form');
        let action = form.attr('action');
        let formData = {
            market_id: $("#export-market-id").val(),
            client_id: $("#export-client-id").val(),
            start_date: export_date.start,
            end_date: export_date.end,
        };

        $.ajax({
            url: action,
            type: 'POST',
            data: formData,
            success: function (data) {
                if (data.success) {

                    $('#export-data').val(
                        JSON.stringify({
                            header: data.header,
                            rows: data.rows,
                            market_id: formData.market_id,
                            client_id: formData.client_id,
                            start_date: export_date.start,
                            end_date: export_date.end
                        })
                    );
                    $('#export-save-errors').hide();
                    $('#export-save-form').submit();
                } else {
                    $('#export-save-errors').html(data.errors.join('<br>')).fadeIn();
                }

                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();
            },
            error: function () {
                button.attr('disabled', false);
                button.find('.fa').show();
                button.find('.fa-spinner').hide();
            }
        });
    });
});
